import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import { mapState } from 'vuex';
const generator = `const twins = data;

function generateGradientColorsByIndex(stateIndex) {
  const hue = (stateIndex * 63) % 360;
  const firstColor = \`hsl(\${hue}, 100%, 50%)\`;
  const secondColor = \`hsl(\${hue}, 50%, 50%)\`;
  return [firstColor, secondColor];
}

function getSeriesForState(twin, state, stateIndex) {
  const xyData = [];

  state.history.forEach((dataPoint, index) => {
    xyData.push([index, dataPoint.value === null ? 0 : dataPoint.value]);
  });

  const gradientColors = generateGradientColorsByIndex(stateIndex);

  return {
    name: \`\${twin.title} - \${state.state.key}\`,
    type: "line",
    stack: "Total",
    smooth: true,
    lineStyle: {
      width: 0,
    },
    areaStyle: {
      opacity: 0.8,
      color: newEchartsObject('graphic.LinearGradient', 0, 0, 0, 1, [
        {
          offset: 0,
          color: gradientColors[0],
        },
        {
          offset: 1,
          color: gradientColors[1],
        },
      ]),
    },
    showSymbol: false,
    emphasis: {
      focus: "series",
    },
    data: xyData,
  };
}

let stateIndex = 0;
function getSeriesForTwin(twin) {
  return twin.states.map((state) => getSeriesForState(twin.twin, state, stateIndex++));
}

const series = twins.map((twin) => getSeriesForTwin(twin).flat()).flat();

return {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985",
      },
    },
  },
  legend: {},
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  xAxis: [
    {
      type: "time",
      boundaryGap: false,
      axisLabel: {
        formatter: (value) => formatDateTime(value),
      },
    },
  ],
  yAxis: [
    {
      type: "value",
    },
  ],
  series: series,
};
`;
export default {
  name: 'ChartCustomOptionsEditorCodeEditor',
  props: {
    value: {
      type: Object,
      required: true
    },
    showOptionsPreview: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState('app', ['color'])
  },
  methods: {
    addExampleGenerator() {
      this.setByKey('chartOptions.custom.optionGenerator', generator);
    },
    getByKey(key, defaultValue = undefined) {
      return get(this.value, key, defaultValue);
    },
    setByKey(key, value) {
      const clone = cloneDeep(this.value);
      set(clone, key, value);
      this.$emit('input', clone);
    }
  }
};